<template>
  <div class="container" id="patient-create">
    <patient-info-form @save="createInquiry"
      @cancel="cancelInquiry"
      v-loading.fullscreen.lock="fullscreenLoading"/>

    <!-- Cancel Create Dialog -->
    <el-dialog :visible.sync="control.showCancelCreateDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการลงข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleCancel(false)">ไม่</el-button>
        <el-button type="primary" @click="handleCancel(true)" class="edit">ใช่</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .container {
    padding-left: 200px;
    padding-right: 200px;
  }
</style>

<script>
import PatientInfoForm from '@/components/patient/form/PatientInfoForm'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'
import { Storage } from '@/model/ModelUtil'

export default {
  name: 'PatientCreate',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      control: {
        showCancelCreateDialog: false,
      },
    }
  },
  components: {
    PatientInfoForm,
  },
  methods: {
    cancelInquiry () {
      this.control.showCancelCreateDialog = true
    },
    handleCancel (status) {
      if (status) {
        const lastestTab = Storage.list.from('lastestCustomerBoardTab')
        this.$router.push({ name: 'PatientBoard', query: { tab: lastestTab[0] } })
      }
      this.control.showCancelCreateDialog = false
    },
    async createInquiry (inquiry) {
      try {
        this.fullscreenLoading = true
        await this.$api.Patient.create(this.clearWoundCareData(inquiry))
        this.showSuccessDialog({ name: 'PatientBoard', query: { tab: 'inquiry' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    clearWoundCareData (inquiry) {
      inquiry.skills = inquiry.skills.filter((item) => {
        return item !== 'woundCare'
      })
      switch (inquiry.skillOptions.woundCare.level) {
        case 1:
          inquiry.skills.push('woundCareLevel1')
          break
        case 2:
          inquiry.skills.push('woundCareLevel2')
          break
        case 3:
          inquiry.skills.push('woundCareLevel3')
          break
        case 4:
          inquiry.skills.push('woundCareLevel4')
          break
      }
      inquiry.skillOptions.woundCare.level = 0
      return inquiry
    },
  },
}
</script>
